var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionCreator = void 0;

var contentful_page_preview_1 = require("@wheelroom/contentful-page-preview");

var getters_1 = require("./getters");

exports.actionCreator = function (state, dispatch) {
  var fetchPage = function fetchPage(adminCoreState) {
    var pagePreviewStore = getters_1.getPreviewPageStore(adminCoreState);

    if (!pagePreviewStore) {
      return;
    }

    if (pagePreviewStore.state.isFetching) {
      return;
    }

    var pageProps = adminCoreState.pageProps;
    var entryId = pageProps.pageContext.pageContentfulId;
    var previewSecrets = pageProps.data.site.siteMetadata.secrets;
    var locale = pageProps.pageContext.locale;

    if (!pageProps.pageContext.pageContentfulId) {
      console.log('Warning: Could not find field contentful_id, is it present in the page query?');
    }

    function getPreviewPage(dispatch) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var pagePreview, fetchedPage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pagePreview = contentful_page_preview_1.createPagePreview({
                  entryId: entryId,
                  locale: locale,
                  previewSecrets: previewSecrets,
                  include: 10,
                  maxDepth: 8
                });
                _context.next = 3;
                return pagePreview.getGatbsyFields();

              case 3:
                fetchedPage = _context.sent;
                dispatch({
                  type: 'SET_PREVIEW_PAGE',
                  previewPage: fetchedPage
                });
                dispatch({
                  type: 'SET_IS_FETCHING',
                  isFetching: false
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }

    dispatch({
      type: 'SET_IS_FETCHING',
      isFetching: true
    });
    getPreviewPage(dispatch);
  };

  return {
    fetchPage: fetchPage
  };
};